import { Components, Theme } from '@mui/material';
import { badgeClasses, getBadgeSizeCss } from './constants';

export const MuiBadge: Components<Theme>['MuiBadge'] = {
  defaultProps: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    overlap: 'circular',
  },
  styleOverrides: {
    root: {
      ...getBadgeSizeCss('xl'),
      ...getBadgeSizeCss('lg'),
      ...getBadgeSizeCss('md'),
      ...getBadgeSizeCss('sm'),
      ...getBadgeSizeCss('xs'),
      [`&.${badgeClasses.xs} .${badgeClasses.badge}`]: {
        display: 'none',
      },
    },
  },
};
